export default {
  props: {
    hidden: Boolean
  },
  computed: {
    getAppVersion() {
      return this.$state.appVersion;
    },
    CurrentRouteName() {
      return this.$route.name;
    },
    userSubscription() {
      return this.$store.getters.currentUserSubscription;
    }
  },
  methods: {
    MinimizeWindow: async function () {
      if (this.$state.embedded) {
        await this.$desktopAppComunication("Minimize");
      }
    },
    MaximizeWindow: async function () {
      if (this.$state.embedded) {
        await this.$desktopAppComunication("Maximize");
      }
    },
    CloseWindow: async function () {
      if (this.$state.embedded) {
        await this.$desktopAppComunication("CloseWindow");
      }
    },
    RemainingSubscriptionTime: function (date) {
      date = new Date(date) - new Date();
      const seconds = Math.floor(date / 1000);
      let interval = seconds / 31536000;
      const years = Math.floor(interval);
      if (interval > 1) {
        return this.$st('utils.timeleft', {
          date: '<span class="text-cta2-100">' + (years + ' ' + this.$st('utils.year', years)) + '</span>'
        }, years);
      }
      interval = seconds / 2592000;
      const months = Math.floor(interval);
      if (interval > 1) {
        return this.$st('utils.timeleft', {
          date: '<span class="text-cta2-100">' + (months + ' ' + this.$st('utils.month', months)) + '</span>'
        }, months);
      }
      interval = seconds / 86400;
      const days = Math.floor(interval);
      if (interval > 1) {
        return this.$st('utils.timeleft', {
          date: '<span class="text-cta2-100">' + (days + ' ' + this.$st('utils.day', days)) + '</span>'
        }, days);
      }
      interval = seconds / 3600;
      const hours = Math.floor(interval);
      if (interval > 1) {
        return this.$st('utils.timeleft', {
          date: '<span class="text-cta2-100">' + (hours + ' ' + this.$st('utils.hour', hours)) + '</span>'
        }, hours);
      }
      interval = seconds / 60;
      const minutes = Math.floor(interval);
      if (interval > 1) {
        return this.$st('utils.timeleft', {
          date: '<span class="text-cta2-100">' + (minutes + ' ' + this.$st('utils.minute', minutes)) + '</span>'
        }, minutes);
      }
      return 'now';
    }
  }
};